module.exports = __webpack_public_path__ + "img/user-default.f3ee5cd3.svg";